// Mock data for consultations
export const mockConsultations = [
  {
    id: '1',
    patientName: 'John Smith',
    patientAge: 45,
    patientGender: 'Male',
    status: 'new',
    timestamp: '2023-06-15T10:30:00Z',
    complaints: 'Severe headache and dizziness',
    start_time: 'Yesterday evening',
    characteristics: 'Throbbing pain on the right side of the head',
    pain_severity: '8/10',
    other_symptoms: 'Nausea, sensitivity to light',
    medication_taken: 'Ibuprofen 400mg',
    improvement_with_medication: 'Slight improvement, but pain returned after a few hours',
    additional_illnesses: 'Hypertension',
    additional_medications: 'Lisinopril 10mg daily',
    messageCount: 8,
    communicationPreference: 'video',
    conversation: [
      {
        sender: 'patient',
        content: 'Hello, I\'ve been having a severe headache since yesterday evening.',
        timestamp: '2023-06-15T10:30:00Z'
      },
      {
        sender: 'ai',
        content: 'I\'m sorry to hear that. Can you describe the pain? Is it throbbing, sharp, or dull?',
        timestamp: '2023-06-15T10:31:00Z'
      },
      {
        sender: 'patient',
        content: 'It\'s a throbbing pain on the right side of my head. It\'s about 8/10 in severity.',
        timestamp: '2023-06-15T10:32:00Z'
      },
      {
        sender: 'ai',
        content: 'Thank you for that information. Are you experiencing any other symptoms along with the headache, such as nausea, vomiting, sensitivity to light or sound?',
        timestamp: '2023-06-15T10:33:00Z'
      },
      {
        sender: 'patient',
        content: 'Yes, I feel nauseous and I\'m sensitive to light. I haven\'t vomited though.',
        timestamp: '2023-06-15T10:34:00Z'
      },
      {
        sender: 'ai',
        content: 'Have you taken any medication for the headache? If so, what did you take and did it help?',
        timestamp: '2023-06-15T10:35:00Z'
      },
      {
        sender: 'patient',
        content: 'I took Ibuprofen 400mg last night. It helped a little but the pain came back after a few hours.',
        timestamp: '2023-06-15T10:36:00Z'
      },
      {
        sender: 'ai',
        content: 'I understand. Based on your symptoms, I think it would be beneficial for you to speak with a healthcare provider. Would you like me to connect you with one of our doctors?',
        timestamp: '2023-06-15T10:37:00Z'
      }
    ]
  },
  {
    id: '2',
    patientName: 'Sarah Johnson',
    patientAge: 32,
    patientGender: 'Female',
    status: 'active',
    timestamp: '2023-06-16T14:45:00Z',
    complaints: 'Persistent cough and chest congestion',
    start_time: 'About a week ago',
    characteristics: 'Productive cough with yellow phlegm',
    pain_severity: 'N/A',
    other_symptoms: 'Low-grade fever, fatigue',
    medication_taken: 'Over-the-counter cough syrup',
    improvement_with_medication: 'Minimal improvement',
    additional_illnesses: 'Asthma',
    additional_medications: 'Albuterol inhaler as needed',
    messageCount: 12,
    communicationPreference: 'call',
    conversation: [
      {
        sender: 'patient',
        content: 'Hi, I\'ve had a persistent cough for about a week now. It\'s getting worse and I\'m coughing up yellow phlegm.',
        timestamp: '2023-06-16T14:45:00Z'
      },
      {
        sender: 'ai',
        content: 'I\'m sorry to hear you\'re not feeling well. Have you been experiencing any other symptoms like fever, fatigue, or shortness of breath?',
        timestamp: '2023-06-16T14:46:00Z'
      },
      {
        sender: 'patient',
        content: 'Yes, I have a low-grade fever and I\'ve been feeling tired. No shortness of breath though.',
        timestamp: '2023-06-16T14:47:00Z'
      },
      {
        sender: 'ai',
        content: 'Thank you for sharing that. Have you taken any medication to help with your symptoms?',
        timestamp: '2023-06-16T14:48:00Z'
      },
      {
        sender: 'patient',
        content: 'I\'ve been taking some over-the-counter cough syrup, but it\'s not helping much.',
        timestamp: '2023-06-16T14:49:00Z'
      },
      {
        sender: 'ai',
        content: 'Do you have any pre-existing medical conditions or are you currently taking any medications?',
        timestamp: '2023-06-16T14:50:00Z'
      },
      {
        sender: 'patient',
        content: 'I have asthma and use an albuterol inhaler when needed.',
        timestamp: '2023-06-16T14:51:00Z'
      },
      {
        sender: 'ai',
        content: 'Given your symptoms and medical history, I recommend speaking with a healthcare provider. Would you like me to connect you with one of our doctors?',
        timestamp: '2023-06-16T14:52:00Z'
      },
      {
        sender: 'patient',
        content: 'Yes, please. I\'d like to speak with a doctor.',
        timestamp: '2023-06-16T14:53:00Z'
      },
      {
        sender: 'ai',
        content: 'I\'ll connect you with a healthcare provider right away. Please stand by.',
        timestamp: '2023-06-16T14:54:00Z'
      },
      {
        sender: 'doctor',
        content: 'Hello Sarah, I\'m Dr. Wilson. I understand you\'ve been experiencing a persistent cough with yellow phlegm, low-grade fever, and fatigue for about a week. Is that correct?',
        timestamp: '2023-06-16T15:00:00Z'
      },
      {
        sender: 'patient',
        content: 'Yes, that\'s right. I\'m concerned because it\'s not getting better.',
        timestamp: '2023-06-16T15:01:00Z'
      }
    ]
  },
  {
    id: '3',
    patientName: 'Robert Chen',
    patientAge: 58,
    patientGender: 'Male',
    status: 'resolved',
    timestamp: '2023-06-14T09:15:00Z',
    complaints: 'Lower back pain',
    start_time: 'Three days ago',
    characteristics: 'Sharp pain when bending or lifting',
    pain_severity: '7/10',
    other_symptoms: 'Stiffness in the morning',
    medication_taken: 'Acetaminophen 500mg',
    improvement_with_medication: 'Moderate relief',
    additional_illnesses: 'Type 2 diabetes',
    additional_medications: 'Metformin 1000mg twice daily',
    messageCount: 15,
    communicationPreference: 'chat',
    conversation: [
      {
        sender: 'patient',
        content: 'Hello, I\'ve been having lower back pain for the past three days. It\'s quite painful when I bend or try to lift something.',
        timestamp: '2023-06-14T09:15:00Z'
      },
      {
        sender: 'ai',
        content: 'I\'m sorry to hear about your back pain. On a scale of 1-10, how would you rate the pain?',
        timestamp: '2023-06-14T09:16:00Z'
      },
      {
        sender: 'patient',
        content: 'I\'d say it\'s about a 7 out of 10.',
        timestamp: '2023-06-14T09:17:00Z'
      },
      {
        sender: 'ai',
        content: 'That sounds quite painful. Did the pain start suddenly, perhaps after an injury or specific movement, or did it develop gradually?',
        timestamp: '2023-06-14T09:18:00Z'
      },
      {
        sender: 'patient',
        content: 'I think it started after I was gardening over the weekend. I didn\'t notice it right away, but by the evening I was in pain.',
        timestamp: '2023-06-14T09:19:00Z'
      },
      {
        sender: 'ai',
        content: 'Have you taken any medication for the pain? If so, has it helped?',
        timestamp: '2023-06-14T09:20:00Z'
      },
      {
        sender: 'patient',
        content: 'I\'ve been taking Acetaminophen 500mg, which helps somewhat but doesn\'t completely relieve the pain.',
        timestamp: '2023-06-14T09:21:00Z'
      },
      {
        sender: 'ai',
        content: 'Do you have any other medical conditions or are you taking any other medications?',
        timestamp: '2023-06-14T09:22:00Z'
      },
      {
        sender: 'patient',
        content: 'I have Type 2 diabetes and take Metformin 1000mg twice daily.',
        timestamp: '2023-06-14T09:23:00Z'
      },
      {
        sender: 'ai',
        content: 'Thank you for sharing that information. I think it would be beneficial for you to speak with a healthcare provider about your back pain. Would you like me to connect you with one of our doctors?',
        timestamp: '2023-06-14T09:24:00Z'
      },
      {
        sender: 'patient',
        content: 'Yes, please. I\'d appreciate that.',
        timestamp: '2023-06-14T09:25:00Z'
      },
      {
        sender: 'doctor',
        content: 'Hello Robert, I\'m Dr. Martinez. I understand you\'ve been experiencing lower back pain for the past three days, particularly when bending or lifting. Is that correct?',
        timestamp: '2023-06-14T09:30:00Z'
      },
      {
        sender: 'patient',
        content: 'Yes, that\'s right. It started after I was gardening over the weekend.',
        timestamp: '2023-06-14T09:31:00Z'
      },
      {
        sender: 'doctor',
        content: 'Based on your description, it sounds like you may have strained your lower back muscles. I recommend rest, applying ice for the first 48-72 hours, and then heat after that. Continue with the acetaminophen as directed, and try to avoid activities that worsen the pain. If the pain persists beyond a week or worsens significantly, please follow up with your primary care physician for an in-person evaluation.',
        timestamp: '2023-06-14T09:35:00Z'
      },
      {
        sender: 'patient',
        content: 'Thank you, Doctor. I\'ll follow your advice and see how it goes.',
        timestamp: '2023-06-14T09:36:00Z'
      }
    ]
  },
  {
    id: '4',
    patientName: 'Emily Rodriguez',
    patientAge: 28,
    patientGender: 'Female',
    status: 'new',
    timestamp: '2023-06-17T11:20:00Z',
    complaints: 'Skin rash and itching',
    start_time: 'Two days ago',
    characteristics: 'Red, raised bumps with intense itching',
    pain_severity: '3/10',
    other_symptoms: 'Mild swelling',
    medication_taken: 'Benadryl',
    improvement_with_medication: 'Temporary relief from itching',
    additional_illnesses: 'Seasonal allergies',
    additional_medications: 'Cetirizine 10mg as needed',
    messageCount: 6,
    communicationPreference: 'video',
    conversation: [
      {
        sender: 'patient',
        content: 'Hi, I\'ve developed a skin rash with intense itching over the past couple of days.',
        timestamp: '2023-06-17T11:20:00Z'
      },
      {
        sender: 'ai',
        content: 'I\'m sorry to hear about your rash. Can you describe what it looks like? For example, is it red, raised, flat, or blistered?',
        timestamp: '2023-06-17T11:21:00Z'
      },
      {
        sender: 'patient',
        content: 'It\'s red and raised, with small bumps. The itching is really intense, especially at night.',
        timestamp: '2023-06-17T11:22:00Z'
      },
      {
        sender: 'ai',
        content: 'Thank you for that description. Where on your body is the rash located? Is it spreading?',
        timestamp: '2023-06-17T11:23:00Z'
      },
      {
        sender: 'patient',
        content: 'It started on my arms but has spread to my torso and neck. It seems to be getting worse.',
        timestamp: '2023-06-17T11:24:00Z'
      },
      {
        sender: 'ai',
        content: 'Have you taken any medication or applied anything to the rash? Also, have you been exposed to any new foods, medications, soaps, or other potential allergens recently?',
        timestamp: '2023-06-17T11:25:00Z'
      }
    ]
  },
  {
    id: '5',
    patientName: 'Michael Brown',
    patientAge: 52,
    patientGender: 'Male',
    status: 'active',
    timestamp: '2023-06-16T08:50:00Z',
    complaints: 'Frequent urination and burning sensation',
    start_time: 'Four days ago',
    characteristics: 'Urgency, burning during urination',
    pain_severity: '5/10',
    other_symptoms: 'Cloudy urine, lower abdominal discomfort',
    medication_taken: 'None',
    improvement_with_medication: 'N/A',
    additional_illnesses: 'Hypertension',
    additional_medications: 'Amlodipine 5mg daily',
    messageCount: 10,
    communicationPreference: 'video',
    conversation: [
      {
        sender: 'patient',
        content: 'Hello, I\'ve been experiencing frequent urination and a burning sensation when I urinate for the past few days.',
        timestamp: '2023-06-16T08:50:00Z'
      },
      {
        sender: 'ai',
        content: 'I\'m sorry to hear you\'re experiencing these symptoms. Have you noticed any other symptoms such as cloudy urine, blood in the urine, or fever?',
        timestamp: '2023-06-16T08:51:00Z'
      },
      {
        sender: 'patient',
        content: 'My urine does look cloudy, and I have some discomfort in my lower abdomen. No blood or fever though.',
        timestamp: '2023-06-16T08:52:00Z'
      },
      {
        sender: 'ai',
        content: 'Thank you for that information. Have you ever experienced these symptoms before or been diagnosed with a urinary tract infection in the past?',
        timestamp: '2023-06-16T08:53:00Z'
      },
      {
        sender: 'patient',
        content: 'No, this is the first time I\'ve had these symptoms.',
        timestamp: '2023-06-16T08:54:00Z'
      },
      {
        sender: 'ai',
        content: 'Do you have any known medical conditions or are you taking any medications?',
        timestamp: '2023-06-16T08:55:00Z'
      },
      {
        sender: 'patient',
        content: 'I have high blood pressure and take Amlodipine 5mg daily.',
        timestamp: '2023-06-16T08:56:00Z'
      },
      {
        sender: 'ai',
        content: 'Based on your symptoms, you may have a urinary tract infection. This is something that should be evaluated by a healthcare provider. Would you like me to connect you with one of our doctors?',
        timestamp: '2023-06-16T08:57:00Z'
      },
      {
        sender: 'patient',
        content: 'Yes, please. I\'d like to speak with a doctor.',
        timestamp: '2023-06-16T08:58:00Z'
      },
      {
        sender: 'doctor',
        content: 'Hello Michael, I\'m Dr. Thompson. I understand you\'ve been experiencing frequent urination, burning during urination, cloudy urine, and lower abdominal discomfort for the past four days. Is that correct?',
        timestamp: '2023-06-16T09:05:00Z'
      }
    ]
  }
]; 